<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form >
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-auto mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="consumoFolha">
						<div class="col-12 card-simple mb-5">
							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-3">
									<label class="label-superior">Produto/Serviço</label>
									<label class="label-inferior">{{ consumoFolha.descricaoItem }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Data Transação</label>
									<label class="label-inferior">{{ consumoFolha.dataTransacao | date:'dd/MM/yyyy' }}</label>
								</div>
								<div class="field col-12 md:col-2">
									<label class="label-superior">Valor de Venda</label>
									<label class="label-inferior" id="valorItem">{{ consumoFolha.valorVendaItem | currency:'BRL' }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Desconto</label>
									<label class="label-inferior">{{ consumoFolha.desconto ? (consumoFolha.desconto / 100 | percent:'1.2-2') : '0.0%' }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Valor a cobrar</label>
									<label class="label-inferior">{{ consumoFolha.valorACobrar | currency:'BRL' }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Quantidade</label>
									<label class="label-inferior">{{ consumoFolha.quantidade }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Valor Total</label>
									<label class="label-inferior">{{ consumoFolha.valorTotal| currency:'BRL' }}</label>
								</div>

								<div class="col-12 md:col-3">
									<label class="label-superior">Profissional</label>
									<label class="label-inferior" id="descricao">{{ consumoFolha.nomeProfissional }}</label>
								</div>
								
								
								<div class="col-12 md:col-2">
									<label class="label-superior">Nº Parcelas</label>
									<label class="label-inferior" id="operacao">{{ consumoFolha.parcelas }}</label>
								</div>

							</div>
						</div>
						

						<div class="w-full mb-5">
							<div>
								<h5>Parcelas</h5>
							</div>
							<p-table #dt1 [value]="parcelasConsumo" dataKey="id" [rows]="10" [rowHover]="true"
							[paginator]="false" responsiveLayout="scroll" styleClass=" p-datatable-sm">
							<ng-template pTemplate="header" >
								<tr>
									<th>
										<div>
											Descrição
										</div>
									</th>
									<th>
										<div>
											Parcela
										</div>
									</th>
									<th>
										<div>
											Data a Cobrar
										</div>
									</th>
									<th>
										<div>
											Valor
										</div>
									</th>
									
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-item let-i="rowIndex">
								<tr>
									<td>
										<label>{{ item.descricao }}</label>
									</td>
									<td>
										<label>{{ item.parcela }}</label>
									</td>
									<td>
										<label>{{ item.dataCompetencia | date:'dd/MM/yyyy' }}</label>
									</td>
									
									<td>
										<label>{{ item.valorRegistro | currency:'BRL' }}</label>
									</td>
									
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="7">Nenhum registro cadastrado.</td>
								</tr>
							</ng-template>
						</p-table>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/consumo"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>